import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";
import Calendario from "@/pages/Calendario";
import Tasks from "@/pages/Tasks";
import Ped from "@/pages/Ped";
import Report from "@/pages/Report";
import Trend from "@/pages/Trend";
import Impostazioni from "@/pages/Impostazioni";
import HubLayout from "@/components/HubLayout";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-greige">
      <span className="meta-label animate-pulse">TWOE CLOUD HUB · CARICAMENTO</span>
    </div>
  );
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "cliente" ? "/calendario" : "/dashboard"} replace />;
  }
  return <HubLayout>{children}</HubLayout>;
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#000",
            color: "#E4E2DD",
            borderRadius: 0,
            border: "none",
            fontFamily: '"DM Sans", sans-serif',
          },
        }}
      />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<Protected roles={["lavoratore"]}><Dashboard /></Protected>} />
      <Route path="/brand" element={<Protected roles={["lavoratore"]}><Brands /></Protected>} />
      <Route path="/brand/:brandId" element={<Protected roles={["lavoratore"]}><BrandDetail /></Protected>} />
      <Route path="/calendario" element={<Protected roles={["lavoratore", "cliente"]}><Calendario /></Protected>} />
      <Route path="/task" element={<Protected roles={["lavoratore"]}><Tasks /></Protected>} />
      <Route path="/ped" element={<Protected roles={["lavoratore"]}><Ped /></Protected>} />
      <Route path="/report" element={<Protected roles={["lavoratore"]}><Report /></Protected>} />
      <Route path="/trend" element={<Protected roles={["lavoratore"]}><Trend /></Protected>} />
      <Route path="/impostazioni" element={<Protected roles={["lavoratore", "cliente"]}><Impostazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
